import { useEffect } from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useScrollClose = (handleClose: () => void): void => {
	useEffect(() => {
		const handleScroll = (): void => {
				handleClose()
		}
		const sidebar = document.getElementById('sidebar')
		if (!sidebar) return
		sidebar?.addEventListener('scroll', handleScroll, true)

		return () => {
			sidebar.removeEventListener('scroll', handleScroll, true)
		}
	}, [handleClose])
}

export default useScrollClose
